/**
 * Viewport-width check that drives the builder's layout switch.
 */

import { useMediaQuery } from "@mantine/hooks";

/**
 * The three-column builder needs the module library (280px), a usable
 * viewport (360px) and the inspector (300px) side by side. Below that the
 * panels move into a bottom sheet and the viewport takes the whole screen.
 */
export const MOBILE_BREAKPOINT = "(max-width: 940px)";

export function useIsMobile(): boolean {
  // Read matchMedia during the first render rather than in an effect: this is
  // a client-only SPA with no markup to hydrate, and deferring it would mount
  // the desktop layout — both panels and their content — on a phone before
  // swapping to the sheet layout one frame later.
  return useMediaQuery(MOBILE_BREAKPOINT, false, { getInitialValueInEffect: false }) ?? false;
}
